module.exports = Utils  = {
    isString(data) {
        return typeof data === 'string' || data instanceof String;
    },
    askToContinue(message,icon,  confirmText = 'Si', cancelText = 'No' ){
        return Swal.fire({
            icon: 'warning',
            title: message,
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#28A745',
            confirmButtonText: confirmText,
            cancelButtonText: cancelText,
        })
    },
    /**
     *
     * @param {number} number
     * @param {number} precision Number of decimal digits
     * @returns {number}
     */
    round(number, precision = 0) {
        let factor = 10 ** precision;
        return Math.round(number * factor) / factor;
    },

    /**
     *
     * @param {string} message
     * @param {number} timer
     * @param {string['success', 'error', 'warning', 'info', 'question']} icon This is a parameter
     * @returns {Promise<SweetAlertResult<Awaited<any>>>}
     */
    showAlert(message, timer = null, icon = '') {
        return Swal.fire({
            ...{
                icon: icon,
                title: message,
                showCancelButton: false
            },
            ...(!!timer) && {timer: timer}
        })
    },
    formatDate(date){
        if(!date) return "N/A";
        if(typeof date == 'string') date =  new Date(date);

        return date.toLocaleString().replaceAll(',','')
    },
    showCustomErrorSweetAlert(errorResponse) {
        let htmlMessage = '';
        let confirmButtonColor = errorResponse.level.toLowerCase() === 'error' ? '#d33' : '#2388fa';
        let currentTime = errorResponse.timestamp;
        if(errorResponse.level.toLowerCase() === 'info' && errorResponse.customCode === 0) {
            errorResponse.level = 'warning';
        }
        let title = errorResponse.level.toLowerCase();
        title = title.charAt(0).toUpperCase() + title.slice(1);
 
        htmlMessage += '<div style="text-align: left; font-weight: bold; font-size: 2ch; max-height: 7.5ch; overflow-y: auto;">' + errorResponse.errorMessage + '</div><hr>';
        if(errorResponse.level.toLowerCase() === 'error' || errorResponse.level.toLowerCase() === 'warning') {
            let htmlTrace = '';
            let firstTraceWithoutVendor_file = '';
            let firstTraceWithoutVendor_line = 0;
            let isFirstTraceWithoutVendor = true;
            htmlTrace += '<div style="text-align: left; max-height: 17.5ch; overflow-y: auto; border-top: 3px solid black; border-bottom: 3px solid black; margin-top: 1ch;">';
            errorResponse.trace.forEach((trace, index) => {
                let extraStyles = '';
                if (trace['file'] && !trace['file'].includes('vendor')) {
                    extraStyles = ' background-color: lightcoral; color: black;';
                    if (isFirstTraceWithoutVendor) {
                        firstTraceWithoutVendor_file = trace['file'];
                        firstTraceWithoutVendor_line = trace['line'];
                        isFirstTraceWithoutVendor = false;
                    }
                }
                htmlTrace += '<div style="text-align: left; margin-bottom: 10px;' + extraStyles + '">';
                htmlTrace += '<strong>[' + (index + 1) + ']</strong><br>';
                if (trace['file'] !== undefined)        htmlTrace += '<strong>File:</strong> ' + trace['file'] + '<br>';
                if (trace['line'] !== undefined)        htmlTrace += '<strong>Line:</strong> ' + trace['line'] + '<br>';
                if (trace['function'] !== undefined)    htmlTrace += '<strong>Function:</strong> ' + trace['function'] + '<br>';
                if (trace['class'] !== undefined)       htmlTrace += '<strong>Class:</strong> ' + trace['class'] + '<br>';
                htmlTrace += '</div> <hr>';
            });
            let path = window.location.pathname;
            htmlMessage += '<div style="text-align: left; font-weight: bold; margin-top: 1ch;">Ruta [' + path + '] Usuario [' + errorResponse.username + '] PC [' + errorResponse.pcName + '] IP ['+ errorResponse.clientIp +'] Fecha [' + currentTime + ']<br>';
            let detailsJsonString = JSON.stringify(errorResponse.details);
            htmlMessage += 'Custom Code [' + errorResponse.customCode + '] Modelo [' + errorResponse.model + ']' + ' Línea [<span style="color: red;">'   + errorResponse.line + '</span>] Archivo <br><span style="color: blue;">' + errorResponse.file + '</span></div>';
            if (firstTraceWithoutVendor_file && firstTraceWithoutVendor_line) {
                htmlMessage += '<div style="text-align: left; font-weight: bold; margin-top: 1ch; background-color: lightcoral; color: black;">';
                htmlMessage += 'Línea [' + firstTraceWithoutVendor_line + '] Archivo<br>';
                htmlMessage += firstTraceWithoutVendor_file;
                htmlMessage += '</div>';
            }
            htmlMessage += '<div style="text-align: left; font-weight: bold; height: 10ch; overflow-y: auto; border-top: 3px solid black; border-bottom: 3px solid black; margin-top: 1ch;">' + detailsJsonString + '</div>';
            htmlMessage += htmlTrace;
            htmlMessage += '</div>';
        }
        else {
            htmlMessage += '<div style="text-align: left; font-weight: bold; font-size: 2.5ch;"> Código: ' + errorResponse.customCode + '</div><hr>';
            htmlMessage += '</div>';
        }
        return Swal.fire({
            icon: errorResponse.level.toLowerCase(),
            title: title,
            html: htmlMessage,
            confirmButtonColor: confirmButtonColor,
            confirmButtonText: 'Aceptar',
            showCloseButton: true,
            width: '70vw',
            allowOutsideClick: false
        });
    },
    showCustomSuccessSweetAlert(message = 'Operación completada') {
        let title = '<span style="font-size: 24px;">' + message + '</span>';
        return Swal.fire({
            backdrop: false,
            background: 'rgba(39, 136, 79, 0.8)',
            color: '#ffffff',
            heightAuto: false,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            title: title,
            width: 350,
        });
    },
    filterList(listData, fields, filter) {
        if (!filter) return listData;
        const searchTerm = String(filter).toLowerCase();
        const searchKeys = fields
          .filter(field => field.key !== 'actions')
          .map(field => field.key);
      
        return listData.filter(item => Utils.listMatchesSearch(item, searchKeys, searchTerm));
      },
      
      valueMatchesSearch(value, searchTerm) {
        if (typeof value === 'object' && value !== null) {
          return Object.values(value).some(subValue =>
            String(subValue).toLowerCase().includes(searchTerm)
          );
        } else {
          return String(value).toLowerCase().includes(searchTerm);
        }
      },
      
      listMatchesSearch(item, searchKeys, searchTerm) {
        return searchKeys.some(key => Utils.valueMatchesSearch(item[key], searchTerm));
      },
      
}